import { render } from "./EventAgregateTable.vue?vue&type=template&id=273c9af9&scoped=true"
import script from "./EventAgregateTable.vue?vue&type=script&lang=js"
export * from "./EventAgregateTable.vue?vue&type=script&lang=js"

import "./EventAgregateTable.vue?vue&type=style&index=0&id=273c9af9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273c9af9"]])

export default __exports__